import { price as priceUtil } from '@eti/utils';
import { ExpandableContent, ScreenReaderPrice } from '@eti/components';
import useId from '../hooks/useId';
import { useToggle } from '../../../common/custom-hooks/toggle';
import { CartRow, Price } from './CartComponents';
import { RowToggle } from './CartToggleableRow';
import CartBreakdownRowAvailability from './CartBreakdownRowAvailability';

export interface CartAvailability {
  airportList: {
    airportName: string;
    numberOfPass: number;
  }[];
  passLabel: string;
}

interface CartFastTrackProps {
  dataTestId: string;
  title: string;
  price: number;
  availability: CartAvailability;
}

const CartBreakdownRow = ({ dataTestId, title, price, availability }: CartFastTrackProps) => {
  const { isOpen, handleToggle } = useToggle(false);
  const uniqueId = useId();
  const { airportList } = availability;

  return (
    <>
      <CartRow data-testid={dataTestId}>
        <RowToggle
          dataTestId={`${dataTestId}-toggle`}
          id={uniqueId}
          isExpanded={isOpen}
          onClick={handleToggle}
        >
          {title}
        </RowToggle>

        {price && (
          <>
            <Price aria-hidden data-testid={`${dataTestId}-price`}>
              {priceUtil.formatPrice(price)}
            </Price>
            <ScreenReaderPrice price={priceUtil.formatPrice(price)} />
          </>
        )}
      </CartRow>

      <ExpandableContent isExpanded={airportList && isOpen}>
        <CartBreakdownRowAvailability availability={availability} dataTestId={dataTestId} />
      </ExpandableContent>
    </>
  );
};

export default CartBreakdownRow;
